export const juniorFinanceResume = `
【職務概要】
財務分野において約3年間の実務経験を持ち、連結決算業務や経営分析、予算管理を中心に取り組んできました。とりわけ国際会計基準（IFRS）に準拠した財務諸表作成に強みがあり、複数の企業における財務報告プロセスの効率化を実現してきました。

業務では、Excel VBAを活用した業務改善や、Power BIを用いた経営指標の可視化に積極的に取り組み、定型業務の自動化によるリソース最適化にも貢献してきました。金融データ分析においては、差異分析や予測モデル構築など、経営判断に資する情報提供を行ってきた経験があります。

今後は、財務知識とITスキルを融合させたデジタルトランスフォーメーション（DX）推進の一翼を担いたいと考えており、CIMA（公認管理会計士）資格取得に向けた学習を進めています。専門性の深化とともに、経営視点を持ったファイナンシャルプロフェッショナルを目指しています。

【職務経歴】
・株式会社Algomaticソリューションズ （2022年4月〜現在）
  ○ 会社概要：グローバル展開するITソリューション企業（従業員約500名）
  ○ 職務内容：財務会計スペシャリスト
    - 月次・四半期・年次の連結決算業務および開示資料作成
    - IFRSに基づく財務諸表作成および会計監査対応
    - 事業部門の予実管理および分析レポート作成
    - 海外子会社（3拠点）との連結調整作業
  ○ 具体的な成果：
    - 連結決算プロセスの見直しにより、決算作業を従来比30%短縮
    - Excel VBAを活用した決算自動化ツールの開発・導入
    - 経営層向け財務ダッシュボードを構築し、意思決定プロセスを改善
  ○ 使用した技術・ツール：
    - SAP（財務モジュール）
    - Excel（VBA、ピボットテーブル、Power Query）
    - Power BI
    - 連結会計システム（DIVA）
  ○ 身につけたスキル：
    - 国際会計基準（IFRS）の実務適用能力
    - 収益認識に関する会計処理
    - グループ企業間取引の連結処理技術

・株式会社Algomaticテクノロジー （2021年4月〜2022年3月）
  ○ 会社概要：国内製造業向けソフトウェア開発企業（従業員約200名）
  ○ 職務内容：経理財務スタッフ
    - 日次・月次の仕訳入力、売掛金・買掛金管理
    - 月次決算業務および報告資料作成
    - 固定資産管理および減価償却計算
    - 資金繰り表作成および資金管理
  ○ 具体的な成果：
    - 請求書処理の電子化を推進し、支払業務の工数を20%削減
    - 売掛金回収率を前年比5%改善する施策を実施
    - 部門別採算管理の仕組みを構築
  ○ 使用した技術・ツール：
    - 会計システム（弥生会計）
    - Microsoft Office（Excel、Word、PowerPoint）
    - 請求書電子化システム
  ○ 身につけたスキル：
    - 日本基準での財務諸表作成能力
    - キャッシュフロー管理手法
    - 管理会計の基礎知識

【受賞・表彰歴】
・2023年度 株式会社Algomaticソリューションズ「業務改善賞」受賞
  - 連結決算業務の効率化とデータ可視化による経営貢献が評価
・2022年度 株式会社Algomaticソリューションズ「新人賞」受賞
  - 業務への迅速な適応力と積極的な業務改善提案が評価

【資格】
・日商簿記検定1級（2022年11月取得）
・TOEIC 780点（2023年6月取得）
・ファイナンシャル・プランニング技能士3級（2021年9月取得）
・MOS Excel エキスパート（2020年5月取得）

【マネジメント経験】
・新入社員指導経験（1名）
  ○ 2023年4月〜2023年9月
  ○ 財務会計業務の基礎教育を担当
  ○ OJTを通じた実務スキル習得サポート
・プロジェクトリーダー経験
  ○ 決算業務効率化プロジェクト（メンバー3名）
  ○ 業務フロー分析からシステム改善までを主導

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 780点（2023年6月取得）
  ○ 海外子会社とのメールやテレカンでのコミュニケーション経験あり
  ○ 英文財務諸表や開示資料の作成経験あり
` as const;
